import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog'

@Injectable({
  providedIn: 'root',
})
export class UIService {
  isBrowser = false

  private viewportHeightSubject = new BehaviorSubject<number>(window.innerHeight);
  viewportHeight$ = this.viewportHeightSubject.asObservable();
  viewportHeight: number

  private modalsCloseState = new BehaviorSubject<boolean>(false);
  public modalsClosed$: Observable<boolean> = this.modalsCloseState.asObservable()

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private ngZone: NgZone,
    private dialogService: MatDialog,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId)

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateViewportHeight.bind(this));
      window.visualViewport.addEventListener('scroll', this.updateViewportHeight.bind(this));
    } else {
      window.addEventListener('resize', this.updateViewportHeight.bind(this));
    }
  }

  setModalsClose(isClosed: boolean): void {
    this.modalsCloseState.next(isClosed)
  }

  setAllDialogsClosed(): void {
    this.setModalsClose(true)
    this.dialogService.closeAll()
  }

  private updateViewportHeight() {
    this.ngZone.run(() => {
      this.viewportHeightSubject.next(window.visualViewport ? window.visualViewport.height : window.innerHeight);
    });
  }
}
